import {
  createStyles, FormControl, FormControlLabel, Grid, makeStyles, Radio, RadioGroup, Theme, withStyles,
} from '@material-ui/core';
import React from 'react';
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';

interface IFormElementWithCheckboxes {
    labelInput: string;
    nameInput: string;
}

const RedRadio = withStyles({
  root: {
    color: '#d0111b',
    '&$checked': {
      color: '#d0111b',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const FormElementWithCheckboxes : React.FC<IFormElementWithCheckboxes> = ({
  labelInput,
  nameInput,
}) => {
  const { control } = useFormContext();
  const classes = useStyles();

  return (
    <Grid container={true} spacing={2} className={classes.formElementControl}>
      <Grid item={true} xs={12} md={4}>
        <div className={classes.formLabelCheckboxes}>
          <p>
            <span>必須</span>
            {labelInput}
          </p>
        </div>
      </Grid>
      <Grid item={true} xs={12} md={8}>
        <Controller
          name={nameInput}
          control={control}
          render={(
            { ref, ...rest }: ControllerRenderProps,
          ) => (
            <FormControl component="fieldset" className={classes.radioGroup}>
              <RadioGroup aria-label="yesno" style={{ flexDirection: 'row', color: '#6F7878' }} {...rest} ref={ref}>
                <FormControlLabel value="true" control={<RedRadio />} label="はい" />
                <FormControlLabel value="false" control={<RedRadio />} label="いいえ" />
              </RadioGroup>
            </FormControl>
          )}
        />
      </Grid>
    </Grid>
  );
};


const useStyles = makeStyles((theme: Theme) => createStyles({
  formElementControl: {
    marginBottom: '30px',
    marginLeft: '10px',
    width: 'calc(100% - 55px)',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      width: '100%',
    },
  },
  formLabelCheckboxes: {
    backgroundColor: '#EBEBEB',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    '& p': {
      fontSize: '18px',
      lineHeight: '26px',
      color: '#1a1a1a',
      letterSpacing: '0.8px',
      fontWeight: 600,
      textAlign: 'center',
      paddingLeft: '12px',
      '& span': {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#ffffff',
        backgroundColor: '#d0111b',
        marginRight: '0.3em',
      },
    },
    [theme.breakpoints.down('sm')]: {
      height: '37px',
    },
  },
  radioGroup: {
    width: '100%',
    height: '100px',
    marginRight: '1em',
    padding: '0 0.5em',
    fontSize: '18px',
    lineHeight: '26px',
    color: '#6F7878',
    letterSpacing: '0.8px',
    fontWeight: 400,
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '50px',
    },
  },


}));
export default FormElementWithCheckboxes;
